import React, {Component} from 'react';
import {Row, Col, Tooltip, Card, CardHeader, CardBody, Button, CardFooter, Table, Badge, ButtonToolbar, CardTitle,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem} from 'reactstrap';
import moment from 'moment';
import LoadingIndicator from '../../../../utils/LoadingIndicator'
import GeneratorTwoDotTwo from './objects/generators/GeneratorTwoDotTwo';
import DeveloperOverviewRender from '../../Developer/DeveloperOverviewRender/DeveloperOverviewRender';
import {ajaxWrapperGet} from "../../../../utils/deviceAPI";
//google maps

const tagBits = [
    { id: "0", text: ".0"},
    { id: "1", text: ".1"},
    { id: "2", text: ".2"},
    { id: "3", text: ".3"},
    { id: "4", text: ".4"},
    { id: "5", text: ".5"},
    { id: "6", text: ".6"},
    { id: "7", text: ".7"},
    { id: "8", text: ".8"},
    { id: "9", text: ".9"},
    { id: "10", text: ".10"},
    { id: "11", text: ".11"},
    { id: "12", text: ".12"},
    { id: "13", text: ".13"},
    { id: "14", text: ".14"},
    { id: "15", text: ".15"},
    { id: "99", text: "noBit"}
];

class Template extends Component {
    constructor(props) {
        super(props);
        this.state = { data: [
                {

                    initializer: 0
                },
                {
                    initializer: 0,
                }

            ],
            loading: true,
            developer:false,
        };
    }
    componentDidMount() {
        this.tick();
        this.timerID = setInterval(
            () => this.tick(),
            10000
        );
    }
    componentWillUnmount(){
        clearInterval(this.timerID);
    }
    componentWillReceiveProps(nextProps) {

        const dev = this.props.device;
        const newDev = nextProps.device;
        if (dev !== newDev ) {
            this.tick(newDev);
        }
    }
    tick(device = this.props.device) {
        ajaxWrapperGet('/api/deviceDataFromSite',device).then((data) => {
            this.setState({
                data,
                loading: false
            });

        });
    }
    returnTagStructure(tags) {
        let returnStructure = [];
        returnStructure.push({ id: "0", text: "notag"});
        Object.keys(tags).forEach(function(key) {
            returnStructure.push({
                id: key,
                text: key
            })
        });
        return returnStructure;
    }
    render() {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }


        let iodb = this.returnTagStructure(this.state.data.iotData);
        console.log(iodb);
        return (
            <div className="containerAnimation">
                <div className="fadeInUp">
                    <DeveloperOverviewRender developer={this.state.developer}
                                             overviewdata={this.props.template}
                                             iodb={iodb}
                                             tagBits={tagBits}
                                             iotData={this.state.data.iotData}
                                             dragtransfer={(rowDataItem,toRowNumber,fromRowNumber) => this.dragTransfer(rowDataItem,toRowNumber,fromRowNumber)}
                                             deleterow={(rowId) => this.deleteItem('row', rowId)}
                                             expandchildsize={(rowId, itemId) => this.expandChildSize(rowId, itemId)}
                                             deletecomponent={(rowId, itemId) => this.deleteItem('component',rowId, itemId)}
                                             selectedrow={(row) => this.setState({selectedRow: row})}
                                             savetextvaluechanges={(row,component,textFieldName,textFieldValue) => this.saveTextValueChanges(row,component,textFieldName,textFieldValue)}
                                             addNewDataToChild={(schema, rowId, itemId) => this.addNewDataToChild(schema, rowId, itemId)}
                                             componentIsBeingEdited={(status) => this.componentIsBeingEdited(status)}

                    />
                </div>
            </div>

        )
    }
}

export default Template;





// WEBPACK FOOTER //
// ./src/views/site/Overview/Templates/Template.js